(function ($) {
  const cached = {email: ''}

  let formValidated = false

  $(document).on('submit', '.form-signup', handleFormSubmitSignupForm)

  /**
   * Handle signup form submission
   *
   * @param e
   * @returns {Promise<void>}
   */
  async function handleFormSubmitSignupForm(e) {
    if (formValidated) {
      return
    }

    e.preventDefault()

    let $form = $(e.target)
    let values = $form.serializeArray()
      .reduce((formValues, item) => {
        formValues[item.name] = item.value;

        return formValues;
      }, {})

    if (!values.email
      || values.email === cached.email
      || !isValidEmailAddress(values.email)
    ) {
      return false
    }

    cached.email = values.email

    let $submitButton = $('button', $form)
    let $formFields = $('fieldset', $form).attr('disabled', 'disabled')
    $formFields.attr('disabled', 'disabled')
    $submitButton.addClass('loading')

    try {
      let response = await $.ajax(`${sbrSignupConfig.restUrl}/signup`, {
        method: 'POST',
        headers: {
          'X-WP-Nonce': sbrSignupConfig.wpNonce,
        },
        data: {
          ...values,
          nonce: sbrSignupConfig.signupNonce,
        },
      })

      if (!response.success) {
        throw new Error(response)
      }

      if (!values.sourceId) {
        $formFields.removeAttr('disabled')
        formValidated = true
        $submitButton.click()
        return
      }

      $submitButton.removeClass('loading')

      if (response.redirect) {
        window.location.href = response.redirect;
      } else if (response.content) {
        let $previewContent = $('.preview-content')

        $previewContent.fadeOut('slow', () => {
          $form.closest('.signup-unlock').remove()

          switch ($previewContent.data('on-unlock')) {
            case 'replace':
              $previewContent.html(response.content)
              break

            case 'append':
            default:
              const appendedContent = $previewContent.html()
                .replace(/\<\!-- \/?wp\:more --\>/, response.content)
              $previewContent.html(appendedContent)
              break
          }

          $previewContent.removeClass('preview-content')
            .fadeIn('slow')
        })
      } else {
        const confirmMessage = $submitButton.data('confirm-message') ?? 'Thank you for signing up'
        $form.fadeOut('slow', () => {
          $(`<div class="success-message mt-16">${confirmMessage}</div>`).insertAfter($form)
          $form.remove()
        })
      }
    } catch (error) {
      console.error(error.responseText ?? error)
      $formFields.removeAttr('disabled')
      $submitButton.removeClass('loading')
      cached.email = ''
    }
  }

  function isValidEmailAddress(emailAddress) {
    let pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i
    return pattern.test(emailAddress)
  }

})(jQuery);
